const articleCta = document.querySelector('.article__cta[data-scroll]');
const mobile = window.innerWidth < 768;

if (articleCta && mobile) {
  const handleScroll = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableHeight <= 0) {
      return;
    }

    const scrollPercentage = (window.scrollY / scrollableHeight) * 100;

    if (scrollPercentage > 20) {
      articleCta.classList.remove('hidden');
      window.removeEventListener('scroll', handleScroll);
    }
  };

  window.addEventListener('scroll', handleScroll);

  handleScroll();
}

class ArticleContent extends HTMLElement {
  connectedCallback() {
      this.setVariables();
      this.init()
  }

  setVariables() {
      this.articleContentText = this.querySelector('.article__rte');
      this.updateInternalLinksType = this.getAttribute('data-update-internal-links-type');
  }

  init() {
      this.updateInternalLinks();
  }

  updateInternalLinks() {
      if (this.updateInternalLinksType !== 'client-side') return;

      const internalLinks = this.articleContentText.querySelectorAll('a[href]');
      const defaultLang = document.documentElement.getAttribute('default-locale');
      const currentLang = window.Shopify.locale;
      const domain = window.location.origin;
      const domainWithLocale = domain + '/' + currentLang;

      if (currentLang === defaultLang) return;

      internalLinks.forEach(link => {
          const href = link.href;
          if (!href.includes(domainWithLocale)) {
              link.href = link.href.replace(domain, domainWithLocale);
          }
      });
  }
};

if (!customElements.get('article-content')) {
  customElements.define('article-content', ArticleContent);
}
